import React from 'react'
import { Helmet } from 'react-helmet'

interface JsonLdSchemaProps {
  schema: object | object[]
  keyOverride?: string
}

/**
 * JSON-LD Schema component for SEO
 * Renders structured data as JSON-LD script tags in the document head
 *
 * @param schema - The JSON-LD schema object or array of objects
 * @param keyOverride - Optional key to override the default key for React
 */
const JsonLdSchema: React.FC<JsonLdSchemaProps> = ({ schema, keyOverride }) => {
  // Convert schema to JSON string
  const jsonLd = JSON.stringify(schema)

  return (
    <Helmet>
      <script type="application/ld+json" key={keyOverride || 'jsonld-schema'}>
        {jsonLd}
      </script>
    </Helmet>
  )
}

export default JsonLdSchema
